export default "__VITE_PUBLIC_ASSET__c76b1e18__"